'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _experienceDestinations = require('json/experience-destinations.json');

var _experienceDestinations2 = _interopRequireDefault(_experienceDestinations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onChangeDestination = function onChangeDestination(data) {
  // eslint-disable-line
  window.location.href = data.url;
};

var DestinationSelect = function DestinationSelect(props) {
  var destinations = _experienceDestinations2.default && _experienceDestinations2.default.en || [];
  return _react2.default.createElement(
    'select',
    (0, _extends3.default)({}, props.fixValue ? { value: '' } : {}, {
      onChange: function onChange(e) {
        return onChangeDestination(JSON.parse(e.target.value));
      }
    }),
    _react2.default.createElement(
      'option',
      { value: '' },
      props.placeholder
    ),
    (0, _keys2.default)(destinations).map(function (key) {
      return _react2.default.createElement(
        'optgroup',
        { label: key, key: key },
        destinations[key].map(function (city) {
          return _react2.default.createElement(
            'option',
            { key: city.label, value: (0, _stringify2.default)(city) },
            city.label
          );
        })
      );
    })
  );
};

DestinationSelect.propTypes = {
  fixValue: _react.PropTypes.bool,
  placeholder: _react.PropTypes.string,
  onSelect: _react.PropTypes.func
};

DestinationSelect.defaultProps = {
  groupDestinationsByCountry: false,
  onSelect: function onSelect() {}
};

exports.default = DestinationSelect;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/General/ExpDestinationSelect.js
// module id = 1522
// module chunks = 47